module.exports = __webpack_public_path__ + "static/media/017-christmas-island.33ef3375.svg";